module.exports = "pegasus/assets/pexels-photo.png";